import React from 'react';
import PropTypes from 'prop-types';

const StatisticTile = (props) => {
  const { title, data, subTitle, details, icon } = props;
  return (
    <div className="col-3">
      <div className="usage usage-primary">
        <div className="usage-head">
          <span className="usage-head-title">{title}</span>
        </div>
        <div className="usage-resume">
          <div className="usage-data">
            <span data-toggle="counter" data-end={data} data-decimals="1" data-suffix="%" className="usage-counter">{data}</span>
            <span className="usage-title">{subTitle}</span>
            <span className="usage-detail">{details}</span>
          </div>
          <div className="usage-icon"><span className={`icon ${icon}`}></span></div>
        </div>
      </div>
    </div>
  )
}

StatisticTile.propTypes = {
  title: PropTypes.string.isRequired,
  data: PropTypes.string.isRequired,
  subTitle: PropTypes.string.isRequired,
  details: PropTypes.string.isRequired,
  icon: PropTypes.string.isRequired
}

export default StatisticTile;


// WEBPACK FOOTER //
// ./src/components/Statistics/StatisticTile.js